import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { TwcOverlayTemplate, LayoutVersion } from "@/components/signup/layouts";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    OnboardingContainerProps,
    TeamChoiceHeader
} from "../../../components";

export const TwcOnboardingContainer = ({
    header,
    subheader,
    hideSubHeader,
    PreHeader,
    children,
    size = "lg"
}: OnboardingContainerProps & PropsWithChildren) => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    if (twcSignupOverlayEnrolled) {
        return (
            <TwcOverlayTemplate
                productLogo={<TeamworkCollectionLogo shouldShowBrand={false} />}
                header={header}
                subheader={subheader}
                size={size}
                version={LayoutVersion.V4}
            >
                {children}
            </TwcOverlayTemplate>
        );
    }

    return (
        <div css={maxHeightContainer}>
            <div css={container}>
                <TeamChoiceHeader
                    header={header}
                    subheader={subheader}
                    hideSubHeader={hideSubHeader}
                    PreHeader={PreHeader}
                />
                <div css={list}>{children}</div>
            </div>
        </div>
    );
};

const list = css({
    [media.below.sm]: {
        marginBlockEnd: "50px"
    }
});

const container = css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    padding: "0 18px 40px 18px"
});

const maxHeightContainer = css({
    color: wacToken("color.primary.black"),
    margin: "auto",
    fontFamily: wacToken("font.charlie.display"),
    textAlign: "center",
    display: "grid",
    gridTemplateRows: "auto",
    height: "100vh"
});
